import { KeycloakService } from 'keycloak-angular';
import { Injectable } from "@angular/core";
import { Headers } from "@angular/http";
import { AuthenticationService } from "../views/authentication.service";

import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
@Injectable()
export class AuthHeaderService {
  constructor(private _authservice: AuthenticationService,  
    private keycloak:KeycloakService) {}
  getHeader() {
    let header = new Headers();
    let LoginUser = this._authservice.getloginUser();
    if(!this.keycloak.isLoggedIn){
      this.keycloak.logout();
      
    }
    let token = localStorage.getItem('token');
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    header.append("Content-Type", "application/json");
    header.append("Access-Control-Allow-Origin", "*");
    if (token) {
      header.append("Authorization", 'Bearer '+ token);

      header.append("company", localStorage.getItem("selectedCompany"));
      // header.append('Authorization', 'Bearer ' + token);
      header.append("X-Time-Zone", timeZone);
    }
    return header;
  }
  getFileHeader() {
    // let header = new HttpHeaders();
    // let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    // if (token) {
    //   header.append("Authorization", token);
    //   header.append("company", localStorage.getItem("selectedCompany"));
    //   header.append("reportProgress", "true");
    //   header.append("responseType", "json");

    //   // header.append('Authorization', 'Bearer ' + token);
    // }

    let LoginUser = this._authservice.getloginUser();
    // let token = LoginUser != null ? LoginUser.result.token : "";
    // let token = this.keycloak._instance.token;
    let token = localStorage.getItem('token')
    let options = {
      headers: new HttpHeaders({
        Authorization: token,
        company: localStorage.getItem("selectedCompany"),
        reportProgress: "true",
        responseType: "json",
      }),
    };
    return options;
  }
  getContentType_Headers() {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    return headers;
  }
  getHttpHeaders() {
    let loginUser = this._authservice.getloginUser();
    // let token = loginUser ? loginUser.access_token : null;
    // let token = this.keycloak._instance.token;
    let token = localStorage.getItem('token')
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + (token ? token : null),
      }),
    };

    return httpOptions;
  }
}
